/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


import Vue from 'vue';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import global from './global.js'
import api from './api.js'
import lodash from 'lodash'
import store from './store'
import ListData from "./components/table/index.js";
import panel from "./components/panel/details-panel";
import moment from 'moment';

import lockr from "lockr";
import {Decimal} from 'decimal.js-light';



Vue.use(ElementUI);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue();
Vue.prototype.$moment = moment;

import './assets/font/iconfont.css'
import './assets/style/reset.scss'
import './assets/style/style.scss'
Vue.component('list-data', ListData)
Vue.component('panel', panel)

window.Bus = new Vue;
window.VueStore = store;
window._ = lodash;
window.lockr = lockr;
window._g = global;
window.router = router;
window._api = api;
window._d = Decimal;

const app = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/app.js